/* tslint:disable */
/* eslint-disable */
/**
 * Viterbit API
 * This is the documentation for viterbit\'s apps
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InvalidateTokenCommand
 */
export interface InvalidateTokenCommand {
    /**
     * 
     * @type {string}
     * @memberof InvalidateTokenCommand
     */
    refreshToken: string;
}

/**
 * Check if a given object implements the InvalidateTokenCommand interface.
 */
export function instanceOfInvalidateTokenCommand(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "refreshToken" in value;

    return isInstance;
}

export function InvalidateTokenCommandFromJSON(json: any): InvalidateTokenCommand {
    return InvalidateTokenCommandFromJSONTyped(json, false);
}

export function InvalidateTokenCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvalidateTokenCommand {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'refreshToken': json['refreshToken'],
    };
}

export function InvalidateTokenCommandToJSON(value?: InvalidateTokenCommand | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'refreshToken': value.refreshToken,
    };
}

